import type {
  AttachProjectBrandingAssetInput,
  CreateBuilderDocumentInput,
  CreateProjectInput,
  DeleteBuilderDocumentInput,
  DeleteRecordsInput,
  ProjectBulkPatch,
  ProjectRuntimeCommandInput,
  SetPrimaryBuilderDocumentInput,
  UpdateBuilderDocumentInput,
  UpdateProjectWordPressAdminCredentialsInput,
  UpdateProjectInput
} from '@shared/types';
import { showUndoToastForLastAction } from '@renderer/app/undo/undo-toast';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function listProjects() {
  return getDesktopApi().projects.listProjects();
}

export async function getProjectById(projectId: string) {
  return getDesktopApi().projects.getProjectById(projectId);
}

export async function applyBulkProjectPatch(payload: ProjectBulkPatch) {
  const result = await getDesktopApi().projects.applyBulkPatch(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function deleteProjects(payload: DeleteRecordsInput) {
  const result = await getDesktopApi().projects.deleteProjects(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function listDeletedProjects() {
  return getDesktopApi().projects.listDeletedProjects();
}

export async function restoreProjects(payload: DeleteRecordsInput) {
  return getDesktopApi().projects.restoreProjects(payload);
}

export async function purgeProjects(payload: DeleteRecordsInput) {
  return getDesktopApi().projects.purgeProjects(payload);
}

export async function createProject(payload: CreateProjectInput) {
  return getDesktopApi().projects.createProject(payload);
}

export async function updateProject(payload: UpdateProjectInput) {
  const result = await getDesktopApi().projects.updateProject(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function updateWordPressAdminCredentials(payload: UpdateProjectWordPressAdminCredentialsInput) {
  return getDesktopApi().projects.updateWordPressAdminCredentials(payload);
}

export async function attachProjectBrandingAsset(payload: AttachProjectBrandingAssetInput) {
  return getDesktopApi().projects.attachProjectBrandingAsset(payload);
}

export async function createBuilderDocument(payload: CreateBuilderDocumentInput) {
  return getDesktopApi().projects.createBuilderDocument(payload);
}

export async function updateBuilderDocument(payload: UpdateBuilderDocumentInput) {
  return getDesktopApi().projects.updateBuilderDocument(payload);
}

export async function deleteBuilderDocument(payload: DeleteBuilderDocumentInput) {
  return getDesktopApi().projects.deleteBuilderDocument(payload);
}

export async function setPrimaryBuilderDocument(payload: SetPrimaryBuilderDocumentInput) {
  return getDesktopApi().projects.setPrimaryBuilderDocument(payload);
}

export async function provisionProjectRuntime(payload: ProjectRuntimeCommandInput) {
  return getDesktopApi().projects.provisionProjectRuntime(payload);
}

export async function updateProjectRuntime(payload: ProjectRuntimeCommandInput) {
  return getDesktopApi().projects.updateProjectRuntime(payload);
}

export async function getProjectRuntimeStatus(projectId: string) {
  return getDesktopApi().projects.getProjectRuntimeStatus(projectId);
}

export async function openProjectLocalUrl(projectId: string) {
  return getDesktopApi().projects.openProjectLocalUrl(projectId);
}
